/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import customBreakpoints from '../../../helpers/customBreakpoints';

// eslint-disable-next-line import/prefer-default-export
export const ModifyDatesStyle = (palette, breakpoints) => ({
    CTAButtonContainer: {
        display: 'flex',
    },
    goBackButton: {
        marginRight: '2vw',
    },
    CTAButtons: {
        textTransform: 'capitalize',
        fontWeight: 'bold',
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '20px',
        },
        width: '100%'
    },
    nextButton: {
        backgroundColor: palette.colorPrimaryAccountCtaButton,
        color: palette.common.white || '#fff',
        textTransform: 'capitalize',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: palette.colorPrimaryAccountCtaButton,
            opacity: .90,
        },
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '20px',
        },
    },
    // This class style should be removed
    backButton: {
        textTransform: 'capitalize',
        fontWeight: 'bold',
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '20px',
        },
    },
    buttonWrap: {
        position: 'sticky',
        bottom: 0,
        backgroundColor: palette.common.white || '#fff',
    },
    buttonWrapInit: {
        position: 'sticky',
        bottom: 0,
        backgroundColor: palette.common.white || '#fff',
    },
    selectedDateDetails: {
        fontSize: '16px',
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: '14px',
        },
    },
    title: {
        textTransform: 'uppercase',
        marginRight: '5px',
        color: palette.text.secondary,
        fontSize: '18px',
    },
    originalDate: {
        marginTop: '20px',
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            marginTop: '-11vh',
            textAlign: 'center',
        },
    },
    modifiedDateWrap: {
        backgroundColor: palette.colorNeutral20,
        border: `1px solid ${palette.common.grey}`,
        padding: '10px',
        height: 'fit-content',
        borderRadius: '5px',
        marginBottom: '60px',
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '100%',
            margin: '10px auto',
            textAlign: 'center',
            marginTop: '-8vh',
        },
    },
    error: {
        fontSize: '13px',
        width: '85%',
        margin: '-84px auto',
        color: palette.error.main || '#ff0000',
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '100%',
            margin: '-32px auto',
            textAlign: 'center',
        },
    },
    deliveryDateBlank: {
        [breakpoints.up(customBreakpoints.tabLandscape)]: {
            height: '306px',
        },
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            height: '474px',
        },
    },
    dayPickerContainer: {
        [breakpoints.up(customBreakpoints.tabPortrait)]: {
            display: 'flex',
        },
        '& .rdp': {
            margin: '0 0 1em 0',
            '& .rdp-day_selected': {
                backgroundColor: palette.colorPrimaryAccountCtaButton,
            },
            '& .rdp-day_disabled': {
               '&:hover': {
                  backgroundColor: 'inherit',
                  color: 'inherit',
              },
            },
            '& .rdp-button:hover:not([disabled]):not(.rdp-day_selected)': {
                backgroundColor: palette.colorPrimaryAccountCtaButton,
                color: palette.common.white,
                opacity: '0.5',
            },
        },
        '& h5': {
            fontSize: '18px',
            margin: '10px 0',
            paddingLeft: '0.25em',
            [breakpoints.up(customBreakpoints.tabPortrait)]: {
                marginLeft: '1em',  
            },
            '& p': {
                fontWeight: 400,
                fontSize: '16px',
                marginTop: '0',
            },
        },
    },
    modifyDateWrapper: {
        [breakpoints.up(customBreakpoints.tabLandscape)]: {
            height: '335px',
        },
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            height: '504px',
        },
        '& .react-calendar': {
            width: '350px',
            maxWidth: '100%',
            background: 'white',
            border: '1px solid #a0a096',
            fontFamily: 'Arial, Helvetica, sans-serif',
            lineHeight: '1.125em',
            MozBoxSizing: 'border-box',
            WebkitBoxSizing: 'border-box',
            boxSizing: 'border-box',
            '& *': {
                MozBoxSizing: 'border-box',
                WebkitBoxSizing: 'border-box',
                boxSizing: 'border-box',
                '&::before': {
                    MozBoxSizing: 'border-box',
                    WebkitBoxSizing: 'border-box',
                    boxSizing: 'border-box',
                },
                '&::after': {
                    MozBoxSizing: 'border-box',
                    WebkitBoxSizing: 'border-box',
                    boxSizing: 'border-box',
                },
            },
            '& button': {
                margin: '0',
                fontSize: '1em',
                border: '0',
                outline: 'none',
                '&:enabled': { '&:hover': { cursor: 'pointer' } },
            },
        },
        '& .react-calendar--doubleView': {
            width: '700px',
            '& .react-calendar__viewContainer': {
                display: 'flex',
                margin: '-0.5em',
                '& >*': { width: '50%', margin: '0.5em' },
            },
        },
        '& .react-calendar__navigation': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '44px',
            '& button': {
                minWidth: '44px',
                background: 'none',
            },
            '& .react-calendar__navigation__arrow': {
                fontSize: '1.4em',
                width: '50px',
            },
        },
        '& .react-calendar__month-view__weekdays': {
            textAlign: 'center',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontSize: '0.75em',
        },
        '& .react-calendar__month-view__weekdays__weekday': { padding: '0.5em' },
        '& .react-calendar__month-view__weekNumbers': {
            fontWeight: 'bold',
            '& .react-calendar__tile': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0.4em',
            },
        },
        '& .react-calendar__year-view': {
            '.react-calendar__tile': { padding: '2em 0.5em' },
        },
        '& .react-calendar__decade-view': {
            '.react-calendar__tile': { padding: '2em 0.5em' },
        },
        '& .react-calendar__century-view': {
            '.react-calendar__tile': { padding: '2em 0.5em' },
        },
        '& .react-calendar__tile': {
            maxWidth: '100%',
            textAlign: 'center',
            padding: '0.4em',
            background: 'none',
            fontSize: '1em',
            '&:disabled': {
                backgroundColor: '#f0f0f0',
                color: '#757575',
            },
        },
        '& .react-calendar__tile--active': {
            background: '#006edc',
            color: 'white',
            '&:enabled': {
                '&:hover': { background: '#1087ff' },
                '&:focus': { background: '#1087ff' },
            },
        },
        '& .react-calendar__tile--hasActive': {
            background: '#76baff',
            '&:enabled': {
                '&:hover': { background: '#a9d4ff' },
                '&:focus': { background: '#a9d4ff' },
            },
        },
        '& .react-calendar--selectRange': {
            '& .react-calendar__tile--hover': { backgroundColor: '#e6e6e6' },
        },
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
});
